import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import "core-js/modules/es.string.trim";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Message } from "element-ui";
import addgainAdv from "./components/addgainAdv";
import { mapActions } from "vuex";
import { getRoleGameProduct, delRoleGameProduct } from '@/api/auth/onlineUser';
export default {
  name: "authProduct",
  components: {
    addgainAdv: addgainAdv
  },
  data: function data() {
    return {
      tableData: [],
      searchData: {
        page: 1,
        page_size: 10
      },
      rolesAllList: [],
      gameAllList: []
    };
  },
  activated: function activated() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getRoleList();

            case 2:
              _context.next = 4;
              return _this.getGameData();

            case 4:
              _this.getData(_this.searchData.page);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: _objectSpread(_objectSpread({}, mapActions('d2admin/user', ['rolesList'])), {}, {
    getData: function getData(e) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var query;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return getRoleGameProduct(_this2.searchData);

              case 2:
                query = _context2.sent;
                query.data.forEach(function (item) {
                  var role = _this2.rolesAllList.find(function (a) {
                    return a.id == item.role_id;
                  });

                  item.role_name = role ? role.title : '';
                  var gameMarks = item.game ? String(item.game).split(',').filter(Boolean) : [];
                  item.game_name = gameMarks.map(function (mark) {
                    var game = _this2.gameAllList.find(function (b) {
                      return b.game_mark == mark.trim();
                    });

                    return game ? game.game_name : mark.trim();
                  }).join('、');
                });
                _this2.tableData = query.data;
                _this2.total = query.total;

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    getRoleList: function getRoleList(e) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var query;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.rolesList({
                  page_size: -1
                });

              case 2:
                query = _context3.sent;
                _this3.rolesAllList = query.data;

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    getGameData: function getGameData(e) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var query;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this4.$store.dispatch("d2admin/game/GameList");

              case 2:
                query = _context4.sent;
                console.log("query==", query);
                _this4.gameAllList = query || [];

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    handleDelete: function handleDelete(id) {
      var _this5 = this;

      this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return delRoleGameProduct({
                  id: id
                }).then(function (res) {
                  if (res.status == 200) {
                    _this5.getData(_this5.searchData.page);

                    _this5.$message({
                      type: "success",
                      message: "删除成功!"
                    });
                  }
                });

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      })));
    }
  })
};